import React from "react";

const ActiveBlue = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="#007AFF"
            d="M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2s16 7.163 16 16Z"
        />
        <path fill="#fff" d="M26 18a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" />
    </svg>
);

export default ActiveBlue;

